import React, { useState } from 'react';
import { requestTsrCustomerOtp, verifyTsrCustomerOtp } from '../api/tsrFoodCustomerApi';

function VerifyIdentityStep({ onBack, onVerified }) {
  const [channel, setChannel] = useState('phone');
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [otp, setOtp] = useState('');
  const [otpSent, setOtpSent] = useState(false);
  const [maskedIdentifier, setMaskedIdentifier] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [sending, setSending] = useState(false);
  const [verifying, setVerifying] = useState(false);

  const handleSendOtp = async () => {
    try {
      setSending(true);
      setError('');
      setMessage('');
      const response = await requestTsrCustomerOtp({
        channel,
        phone: channel === 'phone' ? phone.trim() : undefined,
        email: channel === 'email' ? email.trim() : undefined
      });
      setOtpSent(true);
      setMaskedIdentifier(response?.data?.maskedIdentifier || '');
      setMessage(response?.message || 'OTP sent successfully.');
    } catch (err) {
      setError(err.message || 'Unable to send OTP.');
    } finally {
      setSending(false);
    }
  };

  const handleVerify = async (event) => {
    event.preventDefault();
    try {
      setVerifying(true);
      setError('');
      const response = await verifyTsrCustomerOtp({
        channel,
        phone: channel === 'phone' ? phone.trim() : undefined,
        email: channel === 'email' ? email.trim() : undefined,
        otp: otp.trim()
      });
      onVerified({
        channel,
        identifier: response?.data?.identifier,
        profile: response?.data?.profile || {}
      });
    } catch (err) {
      setError(err.message || 'Invalid OTP.');
    } finally {
      setVerifying(false);
    }
  };

  return (
    <>
      <div className="modal-body">
        <p className="text-muted mb-3">Verify your phone or email to continue with your order.</p>

        <div className="btn-group mb-3 w-100" role="group">
          <button
            type="button"
            className={`btn btn-sm ${channel === 'phone' ? 'btn-primary' : 'btn-outline-primary'}`}
            onClick={() => { setChannel('phone'); setOtpSent(false); setOtp(''); setError(''); }}
          >
            Phone
          </button>
          <button
            type="button"
            className={`btn btn-sm ${channel === 'email' ? 'btn-primary' : 'btn-outline-primary'}`}
            onClick={() => { setChannel('email'); setOtpSent(false); setOtp(''); setError(''); }}
          >
            Email
          </button>
        </div>

        {error ? <div className="alert alert-danger py-2">{error}</div> : null}
        {message ? <div className="alert alert-success py-2">{message}</div> : null}

        {channel === 'phone' ? (
          <div className="mb-3">
            <label className="form-label">Mobile number</label>
            <input
              type="tel"
              className="form-control"
              placeholder="10-digit mobile number"
              value={phone}
              onChange={(event) => setPhone(event.target.value.replace(/\D/g, '').slice(0, 10))}
              maxLength={10}
            />
          </div>
        ) : (
          <div className="mb-3">
            <label className="form-label">Email address</label>
            <input
              type="email"
              className="form-control"
              placeholder="you@example.com"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
            />
          </div>
        )}

        <button
          type="button"
          className="btn btn-outline-primary w-100 mb-3"
          onClick={handleSendOtp}
          disabled={sending || (channel === 'phone' ? phone.length !== 10 : !email.includes('@'))}
        >
          {sending ? 'Sending OTP...' : 'Send OTP'}
        </button>

        {otpSent && maskedIdentifier ? (
          <p className="small text-muted mb-3">OTP sent to: {maskedIdentifier}</p>
        ) : null}

        <form onSubmit={handleVerify}>
          <label className="form-label">Enter OTP</label>
          <input
            type="text"
            className="form-control mb-3"
            placeholder="6-digit code"
            value={otp}
            onChange={(event) => setOtp(event.target.value.replace(/\D/g, '').slice(0, 6))}
            maxLength={6}
          />
          <button
            type="submit"
            className="btn btn-primary w-100"
            disabled={verifying || otp.length !== 6}
          >
            {verifying ? 'Verifying...' : 'Verify & Continue'}
          </button>
        </form>
      </div>

      <div className="modal-footer">
        <button type="button" className="btn btn-light" onClick={onBack}>Back</button>
      </div>
    </>
  );
}

export default VerifyIdentityStep;
